import React from "react";
import ReactDOM from 'react-dom';
import Countdown from 'react-countdown';
import { NavLink } from "react-router";

import logo from './logo.svg';
import './App.css';

function App() {

  /*ReactDOM.render(
    <Countdown date={Date.now() + 10000} />,
    document.getElementById('root')
  
  #6d0020
  #470015
  #910ca8
  );*/

  return (
    <div className="App bg-black text-white">
      <nav className="pt-12 pb-12 text-left ml-40">
        <NavLink to="/" className="labelText text-5xl font-bold" end>AETEAU</NavLink>
        <p className="text-xl mt-2">Monticello, New York</p>
      </nav>
    </div>
  );
}

export default App;
